import Vue from 'vue'
import Vuex from 'vuex'
import item from './modules/item'
import user from './modules/user'
import price from './modules/price'
import shop from './modules/shop'
import category from './modules/category'
import event from './modules/event'
import orderRecommend from './modules/orderRecommend'
import global from './modules/global'
import menu from './modules/menu'
import qr from './modules/qr'
import oauth from './modules/oauth'
import timeRecommend from './modules/timeRecommend'
import bikkurapon from './modules/bikkurapon'
import error from './modules/error'
import settings from './modules/settings'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

// 初期値
export const initialState = {
  item: {},
  user: {},
  price: {},
  shop: {},
  category: {},
  event: {},
  global: {},
  menu: {},
  orderRecommend: {},
  qr: {},
  oauth: {},
  timeRecommend: {},
  bikkurapon: {},
  error: {},
  settings,
}

const mutations = {
  // State初期化用
  resetVuexState(state) {
    Object.assign(state, JSON.parse(localStorage.getItem('initialState')))
  },
}

export default new Vuex.Store({
  state: initialState,
  mutations: mutations,
  modules: {
    item,
    user,
    price,
    shop,
    category,
    event,
    global,
    menu,
    orderRecommend,
    qr,
    oauth,
    timeRecommend,
    bikkurapon,
    error,
    settings,
  },
  plugins: [
    createPersistedState({
      key: 'smartphone_order',
      storage: window.sessionStorage,
    }),
  ],
})
